/**
 * Pack Variant Picker
 * Custom variant picker for Pack type variants
 * Directly updates the form's variant selector
 */

(function() {
  'use strict';

  /**
   * Initialize Pack Variant Picker
   * @param {HTMLElement} container - The pack variant picker container element
   */
  function initPackVariantPicker(container) {
    if (!container) return;

    const packInputs = container.querySelectorAll('.pack-variant-picker__input');
    const productRoot = container.closest('[data-product-root]');
    const packOptionPosition = container.dataset.packOptionPosition;
    
    if (!productRoot) {
      console.warn('Pack Variant Picker: Could not find product root element');
      return;
    }

    // Find the form's variant ID selector (name="id")
    const variantIdSelect = productRoot.querySelector('select[name="id"]');
    
    console.log('Pack Variant Picker: Initializing');
    console.log('Pack Variant Picker: Found variant ID select:', !!variantIdSelect);

    /**
     * Handle pack option selection
     * @param {Event} event - The change event
     */
    function handlePackSelection(event) {
      const selectedInput = event.target;
      const selectedValue = selectedInput.value;
      const variantId = selectedInput.dataset.variantId;
      
      console.log('Pack Variant Picker: Selection changed to:', selectedValue, 'variantId:', variantId);
      
      if (!variantId) {
        console.warn('Pack Variant Picker: No variant ID found for value:', selectedValue);
        return;
      }

      // Method 1: Update the form's variant ID select directly
      if (variantIdSelect) {
        console.log('Pack Variant Picker: Updating form select to variant ID:', variantId);
        variantIdSelect.value = variantId;
        variantIdSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      
      // Method 2: Also dispatch theme:change:variant event for full UI update
      console.log('Pack Variant Picker: Dispatching theme:change:variant');
      productRoot.dispatchEvent(new CustomEvent('theme:change:variant', {
        bubbles: true,
        detail: { variantId: parseInt(variantId, 10) }
      }));
      
      // Method 3: Try to update Alpine.js component directly
      if (window.Alpine) {
        try {
          const alpineData = Alpine.$data(productRoot);
          if (alpineData) {
            // Find the variant object
            const variant = alpineData.product?.variants?.find(v => v.id === parseInt(variantId, 10));
            if (variant) {
              console.log('Pack Variant Picker: Updating Alpine currentVariant');
              alpineData.currentVariant = variant;
              alpineData.variantChanged = true;
            }
          }
        } catch (e) {
          console.log('Pack Variant Picker: Could not update Alpine directly:', e.message);
        }
      }
      
      // Method 4: Update URL with variant parameter
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }

    // Attach event listeners to pack inputs
    packInputs.forEach(input => {
      input.addEventListener('change', handlePackSelection);
    });

    // Listen for external variant changes and sync back to pack picker
    productRoot.addEventListener('shapes:product:variantchange', function(event) {
      if (event.detail && event.detail.variant) {
        syncPackPickerFromVariant(container, event.detail.variant, packOptionPosition);
      }
    });

    // Also listen on document for theme:variant:change (dispatched by product component)
    document.addEventListener('theme:variant:change', function(event) {
      if (event.detail && event.detail.productRootEl === productRoot && event.detail.variant) {
        syncPackPickerFromVariant(container, event.detail.variant, packOptionPosition);
      }
    });
    
    console.log('Pack Variant Picker: Initialization complete');
  }

  /**
   * Sync pack picker selection from variant
   * @param {HTMLElement} container - The pack variant picker container
   * @param {Object} variant - The variant object
   * @param {string} packOptionPosition - The Pack option position (1-based)
   */
  function syncPackPickerFromVariant(container, variant, packOptionPosition) {
    if (!variant || !variant.options) return;
    
    const packInputs = container.querySelectorAll('.pack-variant-picker__input');
    const optionIndex = packOptionPosition ? parseInt(packOptionPosition, 10) - 1 : null;
    
    // Get the Pack option value from variant options
    let packValue = null;
    if (optionIndex !== null && variant.options[optionIndex]) {
      packValue = variant.options[optionIndex];
    }
    
    // If we couldn't get it by position, try to find it by matching
    if (!packValue) {
      variant.options.forEach(optionValue => {
        packInputs.forEach(input => {
          if (input.value === optionValue) {
            packValue = optionValue;
          }
        });
      });
    }
    
    // Update the pack picker (without triggering change event)
    if (packValue) {
      packInputs.forEach(input => {
        input.checked = (input.value === packValue);
      });
    }
  }

  /**
   * Initialize all pack variant pickers on the page
   */
  function initAllPackVariantPickers() {
    const pickers = document.querySelectorAll('.pack-variant-picker');
    pickers.forEach(initPackVariantPicker);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllPackVariantPickers);
  } else {
    initAllPackVariantPickers();
  }

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    const section = event.target;
    const pickers = section.querySelectorAll('.pack-variant-picker');
    pickers.forEach(initPackVariantPicker);
  });

  // Expose to global scope for external access
  window.PackVariantPicker = {
    init: initPackVariantPicker,
    initAll: initAllPackVariantPickers
  };
})();
